import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";

const initialState = {
checkInListData: {
loading: false,
rows: [],
totalRows: 0,
rowsPerPageOptions: rowsPerPageJsonData,
pageSize: 10,
page: 1 
},
handleCheckInTriggerLoading: false,
checkinGuestList: [],
checkOutListData: {
loading: false,
rows: [],
totalRows: 0,
rowsPerPageOptions: rowsPerPageJsonData,
pageSize: 10,
page: 1 
},
handleCheckOutTriggerLoading: false,
checkOutGuestList: [],
inhouseListData: {
loading: false,
rows: [],
totalRows: 0,
rowsPerPageOptions: rowsPerPageJsonData,
pageSize: 10,
page: 1 
},
handleInhouseTriggerLoading: false,
inhouseGuestList: [],
reservationListData: {
loading: false,
rows: [],
totalRows: 0,
rowsPerPageOptions: rowsPerPageJsonData,
pageSize: 10,
page: 1 
},
handleReservationTriggerLoading: false,
reservationGuestList: [],
pinpadDevicesList: []
};

const dashboardListSlice = createSlice({
  name: "dashboardList",
  initialState: initialState,
  reducers: {
    checkInListSuccess: (state, action) => {
      state.checkInListData = {...state.checkInListData, [action.payload?.key]: action.payload?.value }
    },
    handleCheckInTriggerLoadingSuccess: (state, action) => {
        state.handleCheckInTriggerLoading = true;
      },
    handleCheckInTriggerLoadingFailed: (state, action) => {
    state.handleCheckInTriggerLoading = false;  
    },
    checkinGuestListSuccess: (state, action) => {
        state.checkinGuestList = action.payload;
      },
    checkinGuestListFailed: (state, action) => {
    state.checkinGuestList = [];
    },
    checkOutListSuccess: (state, action) => {
      state.checkOutListData = {...state.checkOutListData, [action.payload?.key]: action.payload?.value }
    },
    handleCheckOutTriggerLoadingSuccess: (state, action) => {
        state.handleCheckOutTriggerLoading = true;
      },
    handleCheckOutTriggerLoadingFailed: (state, action) => {
    state.handleCheckOutTriggerLoading = false;  
    },
    checkOutGuestListSuccess: (state, action) => {
        state.checkOutGuestList = action.payload;
      },
    checkOutGuestListFailed: (state, action) => {
    state.checkOutGuestList = [];
    },
    inhouseListSuccess: (state, action) => {
      state.inhouseListData = {...state.inhouseListData, [action.payload?.key]: action.payload?.value }
    },
    handleInhouseTriggerLoadingSuccess: (state, action) => {
        state.handleInhouseTriggerLoading = true;
      },
    handleInhouseTriggerLoadingFailed: (state, action) => {
    state.handleInhouseTriggerLoading = false;  
    },
    inhouseGuestListSuccess: (state, action) => {
        state.inhouseGuestList = action.payload;
    },
    inhouseGuestListFailed: (state, action) => {
    state.inhouseGuestList = [];
    },
    reservationListSuccess: (state, action) => {
      state.reservationListData = {...state.reservationListData, [action.payload?.key]: action.payload?.value }
    },
    handleReservationTriggerLoadingSuccess: (state, action) => {
        state.handleReservationTriggerLoading = true;
      },
    handleReservationTriggerLoadingFailed: (state, action) => {
    state.handleReservationTriggerLoading = false;  
    },
    reservationGuestListSuccess: (state, action) => {
        state.reservationGuestList = action.payload;
    },
    reservationGuestListFailed: (state, action) => {
    state.reservationGuestList = [];
    },
    pinpadDevicesListSuccess: (state, action) => {
        state.pinpadDevicesList = action.payload;
    },
    pinpadDevicesListFailed: () => {
    state.pinpadDevicesList = [];
    },
    
  },
});

export const {
    checkInListSuccess,
    handleCheckInTriggerLoadingSuccess,
    handleCheckInTriggerLoadingFailed,
    checkinGuestListSuccess,
    checkinGuestListFailed,
    pinpadDevicesListSuccess,
    pinpadDevicesListFailed,
    checkOutListSuccess,
    handleCheckOutTriggerLoadingSuccess,
    handleCheckOutTriggerLoadingFailed,
    checkOutGuestListSuccess,
    checkOutGuestListFailed,
    inhouseListSuccess,
    handleInhouseTriggerLoadingSuccess,
    handleInhouseTriggerLoadingFailed,
    inhouseGuestListSuccess,
    inhouseGuestListFailed,
    reservationListSuccess,
    handleReservationTriggerLoadingSuccess,
    handleReservationTriggerLoadingFailed,
    reservationGuestListSuccess,
    reservationGuestListFailed
} = dashboardListSlice.actions;

export default dashboardListSlice.reducer;
